enum Nav {
  Home = '/',
  Register = '/register',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  SetupPassword = '/setup-password',
  Login = '/login',
  Auth = '/auth',
  Logout = '/logout',
  Templates = '/templates',
  Template = '/templates/:id/*',
  TemplateContract = '/templates/:id/contract',
  Blocks = '/blocks',
  Block = '/blocks/:id',
  Clauses = '/clauses',
  Clause = '/clauses/:id',
  Branding = '/branding',
  BrandingDetails = '/branding/:id',
  Tags = '/tags',
  Teams = '/teams',
  Users = '/users',
  Submissions = '/contracts',
  Submission = '/contracts/:id/*',
  SubmissionForm = '/contracts/:id/form',
  SubmissionContract = '/contracts/:id/contract',
  Endorsements = '/contracts/:id/endorsements',
  Endorsement = '/contracts/:id/endorsements/:endorsement_id/*',
  EndorsementForm = '/contracts/:id/endorsements/:endorsement_id/form',
  EndorsementContract = '/contracts/:id/endorsements/:endorsement_id/contract',
  EndorsementView = '/contracts/:id/endorsements/:endorsement_id/endorsement-view',
  SubmissionsLegacy = '/submissions/*',
  NotFound = '/404',
  PreDraftContract = '/create-contract/:id',
  EvalConfigs = '/eval-configs',
  EvalConfig = '/eval-configs/:id',
  ApiDocs = '/api-docs',
}

type RouteConfig = {
  title: string;
  access: 'private' | 'public';
  layout?: 'user';
};

export const config: Record<Nav, RouteConfig> = {
  [Nav.Home]: { title: 'Home', access: 'private' },
  [Nav.Register]: { title: 'Register', access: 'public' },
  [Nav.ForgotPassword]: { title: 'Forgot Password', access: 'public' },
  [Nav.ResetPassword]: { title: 'Reset Password', access: 'public' },
  [Nav.SetupPassword]: { title: 'Setup Password', access: 'public' },
  [Nav.Login]: { title: 'Login', access: 'public' },
  [Nav.Auth]: { title: 'Auth', access: 'public' },
  [Nav.Logout]: { title: 'Logout', access: 'public' },
  [Nav.Templates]: { title: 'Templates', access: 'private', layout: 'user' },
  [Nav.Template]: { title: 'Template', access: 'private' },
  [Nav.TemplateContract]: { title: 'Template Contract', access: 'private' },
  [Nav.Blocks]: { title: 'Block Library', access: 'private', layout: 'user' },
  [Nav.Block]: { title: 'Block Library', access: 'private', layout: 'user' },
  [Nav.Clause]: { title: 'Clause Library', access: 'private', layout: 'user' },
  [Nav.Clauses]: { title: 'Clause Library', access: 'private', layout: 'user' },
  [Nav.Branding]: { title: 'Branding', access: 'private', layout: 'user' },
  [Nav.BrandingDetails]: { title: 'BrandingDetails', access: 'private', layout: 'user' },
  [Nav.Tags]: { title: 'Tags', access: 'private', layout: 'user' },
  [Nav.Teams]: { title: 'Teams', access: 'private', layout: 'user' },
  [Nav.Users]: { title: 'Users', access: 'private', layout: 'user' },
  [Nav.Submissions]: { title: 'Contracts', access: 'private', layout: 'user' },
  [Nav.Submission]: { title: 'Contract', access: 'private' },
  [Nav.SubmissionForm]: { title: 'Contract Form', access: 'private' },
  [Nav.SubmissionContract]: { title: 'Contract Contract', access: 'private' },
  [Nav.Endorsements]: { title: 'Endorsements', access: 'private' },
  [Nav.Endorsement]: { title: 'Endorsement', access: 'private' },
  [Nav.EndorsementForm]: { title: 'Endorsement Form', access: 'private' },
  [Nav.EndorsementContract]: { title: 'Endorsement Contract', access: 'private' },
  [Nav.EndorsementView]: { title: 'Endorsement View', access: 'private' },
  [Nav.SubmissionsLegacy]: { title: '', access: 'private' }, // Legacy route for submissions, will redirect to /contracts
  [Nav.NotFound]: { title: 'Not Found', access: 'public' },
  [Nav.PreDraftContract]: { title: 'Create Contract', access: 'private' },
  [Nav.EvalConfigs]: { title: 'Eval configs', access: 'private', layout: 'user' },
  [Nav.EvalConfig]: { title: 'Eval config', access: 'private', layout: 'user' },
  [Nav.ApiDocs]: { title: 'API Docs', access: 'private' },
};

export default Nav;
